module.exports = global.config = {
    ////////////////////////////////////////
    url: {
        //client: "http://localhost:3000/",
        //base: "http://localhost:8000/",
        //api: "http://localhost:8000/api/",
        
        client: "https://dx.angiang.vn/",
       base: 'https://dx.angiang.vn/',
       api: 'https://dx.angiang.vn/api/'
        ///rest of your translation object
    },
    key: {
        app: "7yp!F4m78Qp@2tnV",
        encrypt: "jH@05GzMcT$6!",
        log: "HyLY@KwUS!2$$Nf8",
    },
    cates: {
        ////default config cate global
        tbl_cate_ethnic: [],
        tbl_cate_forms_training: [],
        tbl_cate_informatics_certificate: [],
        tbl_cate_language_certificate: [],
        tbl_cate_nationality: [],
        tbl_cate_organize: [],
        tbl_cate_position_party: [],
        tbl_cate_position_trade_union: [],
        tbl_cate_position_union: [],
        tbl_cate_religion: [],
        tbl_product_cate: [],
        dashboards: [],
        isOnline: "",
    },
};
